export default __webpack_public_path__ + "static/appleIcon-d5e34e6f137b459c22a322f4e7c6cc90.png";